import {
  customShadowlessElement,
  correctElementType,
} from "@brytdesigns/web-component-core/utils";
import { KeenSliderNavigationArrows } from "./components/index.js";
import { initializeClasses } from "./utils.js";

export type KeenSliderNavigationArrowsProps = KeenSliderNavigationArrows.Props;

customShadowlessElement(
  KeenSliderNavigationArrows.Name,
  {
    class: "",
    target: "",
    debug: false,
  },
  correctElementType(KeenSliderNavigationArrows.Component),
  //@ts-ignore
  initializeClasses,
);
